module.exports = __webpack_public_path__ + "images/file_icons_v2/deb-630c576d829814978a071ca257d62078.svg";